/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { FormControlLabel, Checkbox, Snackbar, Divider } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";
import { debounce } from "lodash";
import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import AutoForm from "../form/functional/AutoForm";
import "../grid/layout/DataGridMomSysOrderPurchase.css";
import layoutConf from "../../config/layoutConf";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px",
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text,
    },
}));

function EguOutSourcingShipDialog(props) {
    const {
        id,
        schema,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,

        title,
        formId,

        onDialogUpdateDetail,

        ...others
    } = props;

    const classes = useStyles();
    const { t } = useTranslation();

    const [dialogInstance, setDialogInstance] = useState();
    const [okButtonDisabled, setOkButtonDisabled] = useState(true);
    const [formData, setFormData] = useState({});
    const [keepOpen, setKeepOpen] = useState(false);

    const [eguVwOutSourcingPurchaseMaterialNotShipGrid, setEguVwOutSourcingPurchaseMaterialNotShipGrid] = useState();
    const [eguVwOutSourcingPurchaseMaterialNotShipApi, setEguVwOutSourcingPurchaseMaterialNotShipApi] = useState();
    const [eguVwOutSourcingPurchaseMaterialNotShipSelect, setEguVwOutSourcingPurchaseMaterialNotShipSelect] =
        useState();

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    useEffect(() => {
        (async () => {
            if (eguVwOutSourcingPurchaseMaterialNotShipGrid) {
                eguVwOutSourcingPurchaseMaterialNotShipGrid.selectionChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setEguVwOutSourcingPurchaseMaterialNotShipSelect(grid.selectedItems[0]);
                        } else {
                            setEguVwOutSourcingPurchaseMaterialNotShipSelect();
                        }
                    }, 10)
                );

                eguVwOutSourcingPurchaseMaterialNotShipGrid.itemsSourceChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setEguVwOutSourcingPurchaseMaterialNotShipSelect(grid.selectedItems[0]);
                        } else {
                            setEguVwOutSourcingPurchaseMaterialNotShipSelect();
                        }
                    },10)
                );
            }
        })();
    }, [eguVwOutSourcingPurchaseMaterialNotShipGrid]);

    useEffect(() => {
        if (eguVwOutSourcingPurchaseMaterialNotShipSelect) {
            setFormData((formData) => {
                let newFormData = {
                    ...formData,

                    outSourcingId: eguVwOutSourcingPurchaseMaterialNotShipSelect.outSourcingId,

                    orderBuyerId: eguVwOutSourcingPurchaseMaterialNotShipSelect.orderBuyerId,
                    orderBuyerName: eguVwOutSourcingPurchaseMaterialNotShipSelect.orderBuyerName,
                    orderBuyerMaterialCode: eguVwOutSourcingPurchaseMaterialNotShipSelect.orderBuyerMaterialCode,
                    orderBuyerMaterialCodeVer: eguVwOutSourcingPurchaseMaterialNotShipSelect.orderBuyerMaterialCodeVer,
                    orderBuyerMaterialName: eguVwOutSourcingPurchaseMaterialNotShipSelect.orderBuyerMaterialName,

                    planId: eguVwOutSourcingPurchaseMaterialNotShipSelect.planId,
                    outSourcingMaterialCode: eguVwOutSourcingPurchaseMaterialNotShipSelect.outSourcingMaterialCode,
                    outSourcingMaterialCodeVer:
                        eguVwOutSourcingPurchaseMaterialNotShipSelect.outSourcingMaterialCodeVer,
                    outSourcingMaterialName: eguVwOutSourcingPurchaseMaterialNotShipSelect.outSourcingMaterialName,
                    outSourcingQty: eguVwOutSourcingPurchaseMaterialNotShipSelect.outSourcingQty,
                    outSourcingMediumUnitQty: eguVwOutSourcingPurchaseMaterialNotShipSelect.outSourcingMediumUnitQty,
                    outSourcingSmallUnitQty: eguVwOutSourcingPurchaseMaterialNotShipSelect.outSourcingSmallUnitQty,

                    companyCode: eguVwOutSourcingPurchaseMaterialNotShipSelect.companyCode,
                    companyName: eguVwOutSourcingPurchaseMaterialNotShipSelect.companyName,

                    startProcessCode: eguVwOutSourcingPurchaseMaterialNotShipSelect.startProcessCode,
                    startProcessName: eguVwOutSourcingPurchaseMaterialNotShipSelect.startProcessName,
                    endProcessCode: eguVwOutSourcingPurchaseMaterialNotShipSelect.endProcessCode,
                    endProcessName: eguVwOutSourcingPurchaseMaterialNotShipSelect.endProcessName,

                    outSourcingShipDate: new Date(),
                };

                for (const column of schema.columns) {
                    if (column?.defaultValue !== undefined) {
                        newFormData[column.name] = column.defaultValue;
                    }
                }

                return newFormData;
            });
        }
    }, [eguVwOutSourcingPurchaseMaterialNotShipSelect]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const nofifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifySuccess = (msg) => {
        notifySuccess(msg);

        if (eguVwOutSourcingPurchaseMaterialNotShipApi) {
            eguVwOutSourcingPurchaseMaterialNotShipApi.refresh();
        }
    };

    const onDialogInitialized = (instance) => {
        setDialogInstance(instance);

        if (onInitialized) {
            onInitialized(instance);
        }
    };

    const checkItemValidataion = (schema, formData) => {
        for (const column of schema.columns) {
            let [valid, msg] = checkValidation("create", column, column.validation, formData[column.name] || "");

            if (!valid) {
                nofifyWarning(msg);
                return false;
            }
        }

        return true;
    };

    const onApiSuccess = (result) => {
        setKeepOpen((keepOpen) => {
            if (!keepOpen) {
                dialogInstance.hide();

                if (onSuccess) {
                    setTimeout(() => onSuccess(result.data), 0);
                } else {
                    onNotifySuccess(result.data);
                }
            } else {
                if (onSuccess) {
                    setTimeout(() => onSuccess(result.data), 0);
                } else {
                    onNotifySuccess(result.data);
                }
            }

            return keepOpen;
        });
    };

    const onApiFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : JSON.stringify(reason));
    };

    const onOk = (schema, formData) => {
        if (!checkItemValidataion(schema, formData)) {
            console.error("Form Validation Failed");

            return;
        }

        if (schema.validation) {
            let [valid, msg] = checkConditionWithMsg(formData, schema.validation);

            if (!valid) {
                nofifyWarning(t("warning.formDataValidationFail", { msg: msg }));
                return;
            }
        }

        const url = `/api/${schema.name}`;

        const apiData = { ...formData };

        const form = new FormData();

        const json = {};
        const deleted = {};

        if (schema && !schema.columnMap) {
            let columnMap = {};
            schema.columns.map((column) => (columnMap[column.name] = column));
            schema.columnMap = columnMap;
          }
          
        for (const formItem in apiData) {
            if (schema.columnMap && schema.columnMap[formItem] && schema.columnMap[formItem].formItemType === "file") {
                deleted[formItem] = apiData[formItem].deletedFiles;

                for (const file of apiData[formItem].activeFiles) {
                    if (file.type === "url") continue;

                    form.append(formItem, file.file);
                }
            } else {
                if (apiData[formItem] !== undefined) {
                    json[formItem] = apiData[formItem];
                }
            }
        }
        
        // for (const formItem in apiData) {
        //     if (apiData[formItem] !== undefined) {
        //         json[formItem] = apiData[formItem];
        //     }
        // }

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify(json));

        apiClient
            .post(url, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));
    };

    const onCancel = () => {
        setFormData();

        setOkButtonDisabled(true);

        dialogInstance.hide();
    };

    const checkKeepOpen = () => {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={() => setKeepOpen((keepOpen) => !keepOpen)}
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{ flexGrow: 1 }}></div>
            </>
        );
    };

    const onChangeFormData = (formData) => {
        setFormData(formData);

        setOkButtonDisabled(false);
    };

    const onCloseNotification = () => {
        setNotification((notification) => {
            return { ...notification, open: false };
        });
    };

    const onCloseDialog = () => {
        setOkButtonDisabled(true);

        setFormData();

        if (onClose) {
            onClose();
        }
    };

    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="lg"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >
            <DialogHeaderWithClose>
                <DialogTitle>{t("dialog.title.EguOutSourcingShip.create")}</DialogTitle>
            </DialogHeaderWithClose>

            <Divider />

            <DialogContent style={{ padding: "0px", height: "600px" }}>
                <ReflexContainer orientation="vertical">
                    <ReflexElement flex={0.6}>
                        <BasicCrudScreenType
                            id="EguVwOutSourcingPurchaseMaterialNotShip"
                            view="EguVwOutSourcingPurchaseMaterialNotShip"
                            onInitialized={(grid) => {
                                grid.selectionMode = "Row";
                                setEguVwOutSourcingPurchaseMaterialNotShipGrid(grid);
                            }}
                            onApiInitialized={(api) => {
                                setEguVwOutSourcingPurchaseMaterialNotShipApi(api);
                            }}
                            headerTitle={t("term.eguOutSourcingPurchase")}
                            noExcel
                            embededInOtherScreenType
                        />
                    </ReflexElement>

                    <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />

                    <ReflexElement flex={0.4}>
                        <div
                            style={{
                                padding: "16px",
                            }}
                        >
                            <AutoForm
                                id="outsourcing-ship-create-form"
                                schema={schema}
                                mode="edit"
                                initialData={formData}
                                onChange={onChangeFormData}
                            />
                        </div>
                    </ReflexElement>
                </ReflexContainer>

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert onClose={onCloseNotification} variant="filled" severity={notification.severity}>
                        {notification.msg}
                    </Alert>
                </Snackbar>
            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                firstActionComponent={checkKeepOpen}
                labels={[t("common.add")]}
                buttonDisabled={[okButtonDisabled, false]} // [okButtonDisabled, cancelButtonDisabled]
                onOk={() => onOk(schema, formData)}
                onCancel={onCancel}
            />
        </Dialog>
    );
}

export default EguOutSourcingShipDialog;
